// useShoppingCartTicketAnalytics customHook

import { useMemo } from "react";

import useAnalytics from "hooks/analytics/useAnalytics";

const useShoppingCartTicketAnalytics = () => {
  const analyticsHook = useAnalytics({
    isSnackWorkflow: false
  });

  const { logSelectTickets, logRemoveTickets } = analyticsHook;

  return useMemo(() => {
    return {
      logSelectTickets,
      logRemoveTickets
    };
  }, [logSelectTickets, logRemoveTickets]);
};
export default useShoppingCartTicketAnalytics;
